<template>
  <div id="app">
    <!-- <MainPage /> -->
    <router-view/>
    <!-- Toast container for notifications -->
    <b-toaster name="b-toaster-top-right"></b-toaster>
  </div>
</template>

<script>
// import MainPage from "./components/MainPage.vue";

export default {
  name: "App",
  components: {
    // MainPage,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 70px;
}
</style>
